// extracted by mini-css-extract-plugin
export var hide = "Home-module--hide--3eb5e";
export var intro = "Home-module--intro--27aa8";
export var introInstructions = "Home-module--introInstructions--cb550";
export var introSubtitle = "Home-module--introSubtitle--34eb8";
export var introTitle = "Home-module--introTitle--44452";
export var map = "Home-module--map--f550e";